import {Box} from '@mui/material';
import AurBreadcrumb from '../../common/aur-breadcrumb/AurBreadCrumb';
import ConciergeReportsContent from './ConciergeReportsContent';
import ConciergeReportsHeader from './ConciergeReportsHeader';
import {t} from 'i18next';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {setMode} from '../../../redux/slices/conciergeReportSlice';

/**
 * Concierge reports component
 * @returns
 */
const ConciergeReports = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  dispatch(
    setMode(
      location.state?.source
        ? t('conciergeReports.uploadMode')
        : t('conciergeReports.accessMode')
    )
  );

  /**
   * Breadcrumb items with label & path
   */
  const items = [
    {
      label: t('conciergeReports.projectOverview'),
      path: '/welcome-single-client',
    },
    {
      label: t('conciergeReports.title'),
    },
  ];
  return (
    <Box className="concierge-reports-main">
      <Box className="breadcrumb-section">
        <AurBreadcrumb items={items} />
      </Box>
      <ConciergeReportsHeader />
      <ConciergeReportsContent />
    </Box>
  );
};
export default ConciergeReports;
